export const DEVICES = ['mac', 'windows', 'iphone', 'android'] as const;

export const DEVICE_LABELS: Record<(typeof DEVICES)[number], string> = {
  mac: 'Mac (macOS)',
  windows: 'PC (Windows)',
  iphone: 'iPhone (iOS)',
  android: 'Android',
} as const;
